.container {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.colorCircle {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  border: 1px solid #b4b4b4;
  transition: border 0.3s ease;
}

.smallSize {
  width: 30px;
  height: 30px;
}

.largeSize {
  width: 50px;
  height: 50px;
}

.colorCircle:hover {
  border: 1px solid #777;
}

.selected {
  border: 1px solid #222;
  box-shadow:
    rgba(0, 0, 0, 0.12) 0px 1px 2px,
    rgba(0, 0, 0, 0.24) 0px 1px 2px;
}

/* 1) Initial (hidden) tooltip state */
.colorCircle[data-tooltip-name]::after {
  /* content: ''; */
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(0);
  opacity: 0;
  white-space: pre; /* allow newline */
  background-color: #505050;
  color: #fffdf7;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8em;
  text-align: center; /* center lines */
  pointer-events: none;
  transition: opacity 0.9s ease;
  /* transform 0.3s ease; */
}

/* 2) On hover, inject content & animate in */
.colorCircle[data-tooltip-name]:hover::after {
  content: attr(data-tooltip-name) '\A' attr(data-tooltip-code);
  opacity: 1;
  transform: translateX(-50%) translateY(-6px);
}

/* special add‑button styling */
.addCircle {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fffdf7;
  font-size: 1.2em;
}

.modalColorsContainer {
  display: flex;
  justify-content: center;
  margin-top: 25px;
}

@media (max-width: 767px) {
  .container {
    justify-content: center;
  }
}
